export default "__VITE_ASSET__BRuobo3G__"